import { createFileRoute } from '@tanstack/react-router';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { CourseExplorerRoot } from '@/features/manage-courses/components/explorer/CourseExplorerRoot';
import { getCourseComponentsQueryOptions } from '@/features/manage-courses/queries/getCourseComponents';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute(
  '/_app/app/admin-section/manage-courses/$sourcedId'
)({
  component: RouteComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  loaderDeps: ({ search }) => ({
    search,
  }),
  loader: async ({ context, params }) => {
    if (!params.sourcedId) {
      return;
    }

    await context.queryClient.prefetchQuery(
      getCourseComponentsQueryOptions({
        sourcedIds: [params.sourcedId],
      })
    );
  },
  ssr: false,
});

function RouteComponent() {
  const { sourcedId } = Route.useParams();

  const breadcrumbItems: BreadcrumbItemProps[] = [
    {
      label: 'Home',
      link: { to: '/app' },
    },
    {
      label: 'Manage Courses',
      link: { to: '/app/admin-section/manage-courses' },
    },
    {
      label: 'Course Explorer',
      link: {
        to: '/app/admin-section/manage-courses/$sourcedId',
        params: { sourcedId },
      },
    },
  ];

  return (
    <AdminPageContent className="overflow-hidden">
      <AdminPageHeader breadcrumbItems={breadcrumbItems} />
      <CourseExplorerRoot />
    </AdminPageContent>
  );
}
